module.exports = __webpack_public_path__ + "img/icon-visit.087ec8f.png";